export default {
  id: null,
  unidade: null,
  valor: null,
  codigoCliente: null,
  descricaoCliente: null,
  observacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/lpuitemdetalhemodel.js